import * as userAction from "../actions/individualagent.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    selectAgentData: null,
    allAgentData: null,
    listData: null,
    agentpropertyData: null,
    selectedprop: null,
    selectedmarker: null,
    zoom: null,
    center: null,
    recommendationSuccessStatus: null,
    askAQuestionSuccessStatus: null,
    reviewSuccessStatus: null,
    selectedMarkerAgentData: null,
    setonclose: null,
    visibleMarkers: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.UPDATE_SELECTED_AGENT_DATA:
      return Object.assign({}, state, {
        selectAgentData: action.selectAgentData,
        status: action.status,
        loading: true,
      });
    case userAction.UPDATE_ALL_AGENT_DATA:
      return Object.assign({}, state, {
        allAgentData: action.allAgentData,
        status: action.status,
        loading: false,
      });
    case userAction.UPDATE_MAP_LIST_DATA:
      return Object.assign({}, state, {
        listData: action.listData,
        status: action.status,
        loading: false,
      });
    case userAction.UPDATE_AGENTS_PROPERTY_DATA:
      return Object.assign({}, state, {
        agentpropertyData: action.agentpropertyData,
        status: action.status,
        loading: false,
      });
    case userAction.UPDATE_PROPERTY_DATA:
      return Object.assign({}, state, {
        selectedprop: action.selectedprop,
        status: action.status,
        loading: false,
      });
    case userAction.UPDATE_MARKER_PROPERTY_DATA:
      return Object.assign({}, state, {
        selectedmarker: action.selectedmarker,
        status: action.status,
        loading: false,
      });
    case userAction.SET_ZOOM:
      return Object.assign({}, state, {
        zoom: action.zoom,
        status: action.status,
        loading: false,
      });
    case userAction.SET_CENTER:
      return Object.assign({}, state, {
        center: action.center,
        status: action.status,
        loading: false,
      });
    case userAction.SET_RECOMMENDATION_SUCCESS:
      return Object.assign({}, state, {
        recommendationSuccessStatus: action.recommendationSuccessStatus,
        status: action.status,
        loading: false,
      });
    case userAction.SET_ASK_A_QUESTION_SUCCESS:
      return Object.assign({}, state, {
        askAQuestionSuccessStatus: action.askAQuestionSuccessStatus,
        status: action.status,
        loading: false,
      });
    case userAction.SET_REVIEW_SUCCESS:
      return Object.assign({}, state, {
        reviewSuccessStatus: action.reviewSuccessStatus,
        status: action.status,
        loading: false,
      });
    case userAction.SET_SELECTED_MARKER_AGENT_DATA:
      return Object.assign({}, state, {
        selectedMarkerAgentData: action.selectedMarkerAgentData,
        status: action.status,
        loading: false,
      });
    case userAction.SET_ON_CLOSE:
      return Object.assign({}, state, {
        setonclose: action.setonclose,
        status: action.status,
        loading: false,
      });
    case userAction.SET_VISIBLE_MARKERS:
      return Object.assign({}, state, {
        visibleMarkers: action.visibleMarkers,
        status: action.status,
        loading: false,
      });
    default:
      return state;
  }
};
export default user;
